import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
import HighchartsNoData from 'highcharts/modules/no-data-to-display';

HighchartsMore(Highcharts);
HighchartsSolidGauge(Highcharts);
HighchartsNoData(Highcharts);

const defaultOptions = {
  highcharts: Highcharts,
  options: {
    plotOptions: {
      series: {
        animation: false,
        cursor: 'pointer',
      },
      solidgauge: {
        colorByPoint: false,
        dataLabels: {
          enabled: false,
        },
        linecap: 'round',
        stickyTracking: false,
        rounded: true,
      },
    },
    yAxis: {
      min: 0,
      max: 100,
      lineWidth: 0,
      tickPositions: [],
    },
    pane: {
      startAngle: 0,
      endAngle: 360,
    },
    chart: { type: 'solidgauge' },
  },
};

const SolidGauge = ({ highchartsOptions }) => {
  const finalConfig = _.merge({}, defaultOptions, highchartsOptions);

  return (
    <HighchartsReact
      {...finalConfig}
      containerProps={{
        style: { width: '100%', height: '100%' },
      }}
    />
  );
};

SolidGauge.propTypes = {
  highchartsOptions: PropTypes.shape().isRequired,
};

export default SolidGauge;
